<div class="form-field">
  <hgroup>
    <label for="">
      @if (customTitle()) {
        <ng-content></ng-content>
      } @else {
        Allegati
      }
      @if (showCount()) {
        <span>({{ attachmensUploadHandler().count$ | async }})</span>
      }
    </label>

    <div class="buttons">
      @if (attachmensUploadHandler().hasRetry$ | async) {
        <button
          appButton
          size="md"
          [iconPosition]="'only-icon'"
          [color]="'transparent'"
          [icon]="'file-upload'"
          [disabled]="attachmensUploadHandler().getFileUpload()?.uploading"
          [pTooltip]="'i18n.AttachmentsManager.retry' | translate"
          [tooltipPosition]="'bottom'"
          (click)="attachmensUploadHandler().getFileUpload()?.upload()"></button>

        <button
          appButton
          size="md"
          [iconPosition]="'only-icon'"
          [color]="'danger'"
          [icon]="'close'"
          [disabled]="attachmensUploadHandler().getFileUpload()?.uploading"
          [pTooltip]="'i18n.AttachmentsManager.abort' | translate"
          [tooltipPosition]="'bottom'"
          (click)="attachmensUploadHandler().clear()"></button>
      }

      @if (attachmensUploadHandler().canEdit) {
        <button
          appButton
          size="md"
          [iconPosition]="'only-icon'"
          [icon]="'add'"
          [disabled]="attachmensUploadHandler().getFileUpload()?.uploading"
          [color]="'transparent'"
          [pTooltip]="'i18n.AttachmentsManager.add' | translate"
          [tooltipPosition]="'bottom'"
          (click)="attachmensUploadHandler().getFileUpload()?.choose()"></button>
      }
    </div>
  </hgroup>

  <p-fileUpload
    accept="image/*, application/pdf, application/csv"
    maxFileSize="5000000"
    [customUpload]="true"
    [multiple]="true"
    (onSelect)="upload()"
    (uploadHandler)="upload()">
    <ng-template pTemplate="header"></ng-template>

    <ng-template
      let-files
      let-uploadedFiles="uploadedFiles"
      let-removeFileCallback="removeFileCallback"
      let-removeUploadedFileCallback="removeUploadedFileCallback"
      pTemplate="content">
      @if (files?.length > 0) {
        <div class="file-list to-upload">
          @for (file of files; track file; let index = $index) {
            <app-attachment-item
              class="p-fileupload-row"
              [attachmentItem]="{
                state: 'uploading',
                file: file
              }"
              [canEdit]="false"
              [nameEditable]="false"
              [isImage]="isImage(file.type)"
              [uploading]="attachmensUploadHandler().getFileUpload()?.uploading"
              (removeUploading)="attachmensUploadHandler().removeFile($event, index)" />
          }
        </div>
      }

      @if (uploadedFiles?.length > 0) {
        <div class="file-list uploaded">
          @for (file of uploadedFiles; track file; let index = $index) {
            @if (resolveUploadedStorageObject | call: file; as so) {
              <app-attachment-item
                class="p-fileupload-row"
                [attachmentItem]="{
                  state: 'uploaded',
                  file: file,
                  so: resolveUploadedStorageObject | call: file
                }"
                [canEdit]="attachmensUploadHandler().canEdit"
                [nameEditable]="attachmensUploadHandler().isNameEditable"
                [isImage]="isImage(file.type)"
                [uploading]="attachmensUploadHandler().getFileUpload()?.uploading"
                (nameChanged)="attachmensUploadHandler().updateName(so.id, $event)"
                (removeUploaded)="attachmensUploadHandler().removeUploaded(index)" />
            }
          }
        </div>
      }

      <div class="file-list">
        @for (file of attachmensUploadHandler().existent$ | async; track file; let index = $index) {
          <app-attachment-item
            class="p-fileupload-row"
            [attachmentItem]="{
              state: 'existent',
              so: file.so
            }"
            [canEdit]="attachmensUploadHandler().canEdit"
            [nameEditable]="attachmensUploadHandler().isNameEditable"
            [isImage]="isImage(file.so.contentType)"
            [uploading]="attachmensUploadHandler().getFileUpload()?.uploading"
            (nameChanged)="attachmensUploadHandler().updateName(file.so.id, $event)"
            (removeExistent)="attachmensUploadHandler().removeExistent(file.so)" />
        }
      </div>
    </ng-template>
    <ng-template
      let-file
      pTemplate="file"></ng-template>
    <ng-template pTemplate="empty">
      @if ((attachmensUploadHandler().count$ | async) === 0) {
        @if (attachmensUploadHandler().canEdit) {
          <div id="dropzone-placeholder">
            {{ 'i18n.AttachmentsManager.dragAndDrop' | translate }}
          </div>
        } @else {
          <i class="grid h-10 place-content-center text-center align-middle text-sm text-surface-400">{{
            'i18n.AttachmentsManager.noAttachment' | translate
          }}</i>
        }
      }
    </ng-template>
  </p-fileUpload>
</div>
